var Wdot;
(function (Wdot) {
    var BaseSelectedItem = (function () {
        function BaseSelectedItem() {
        }
        BaseSelectedItem.prototype.getUpdatedNearbyLocations = function (latitutde, longitutde) {
            //2023-05-22-JK: I THINK THIS IS OBSOLETE NOW. Removed during gulp update. It's only referenced by buttons and the reordering functionality has been removed. This controller is gone. There's no action to hit
            // var options = {
            //     //"placeTypeId": $('#js-admin-nearby-locations').data('place-type-id'),
            //     "placeTypeId": $("#PlaceType_Id").val(),
            //     "latitutde": latitutde,
            //     "longitutde": longitutde,
            //     "itemId": $("#Id").val()
            // };
            // var ajax = new Wdot.Ajax();
            // ajax.Get('/admin/help/GetUpdatedNearbyLocations', options, function (data) {
            //     if ($('#nearby-locations-wrapper')) {
            //         $('#nearby-locations-wrapper').html(data);
            //     }
            // });
        };
        return BaseSelectedItem;
    }());
    Wdot.BaseSelectedItem = BaseSelectedItem;
})(Wdot || (Wdot = {}));
//# sourceMappingURL=BaseSelectedItem.js.map